import React from 'react'
import { Link } from 'react-router-dom'
import MediaQuery from 'react-responsive'
import 'font-awesome/css/font-awesome.min.css'
import { FormattedMessage, injectIntl } from 'react-intl'

import { nl2Br } from '../Functions'
import GAMES from '../Games.json'
import logo from '../images/dg_logo.png'
import logoSmall from '../images/dg_logo_small.png'
import footerIsotype from '../images/dg_isotype_footer.png'

import './Menu.css'

const Menu = (props) => (
  <div className="main-menu-container">
    <header>
      <MediaQuery maxWidth={767}>
        <div id="logo"><img src={logoSmall} alt="DrummerGames Logo"/></div>
      </MediaQuery>
      <MediaQuery minWidth={768}>
        <div id="logo"><img src={logo} alt="DrummerGames Logo"/></div>
      </MediaQuery>
    </header>
    <main>
      <nav id="main-menu">
        { Object.keys(GAMES).map((key) => 
            <Link to={'/game/'+key} key={key} className={'main-menu-button' + (GAMES[key].bases.type === 'abc' ? ' staff' : '')} >
              {nl2Br(GAMES[key]['name'][props.intl.locale])}
            </Link>) }
      </nav>
    </main>
    <footer>
      <div className="footer-line" id="footer-author">
        <img src={footerIsotype} alt="DrummerGames Isotype"/>&nbsp;
        DrummerGames 0.6.0
        <div className="sep">·</div>
        <FormattedMessage id="menu.by"/>{' '}
        <a href="https://facebook.com/rigobauer">A. Iglesias</a>
      </div>
      <div className="sep" id="sep-email">·</div>
      <div className="footer-line" id="footer-email">
        <a href="mailto:drummergamesco@gmail.com">drummergamesco@gmail.com</a>
      </div>
      <div className="sep" id="sep-social">·</div>
      <div className="footer-line" id="footer-social">
        <FormattedMessage id="menu.followUs"/>
        &nbsp;<a href="https://www.youtube.com/channel/UC1hl8xRQMajmBI7wD4_mYGA"><i className="fa fa-lg fa-youtube-play" aria-label="Youtube logo"></i></a>
        &nbsp;<a href="https://facebook.com/drummergamesco"><i className="fa fa-lg fa-facebook-square" aria-label="Facebook logo"></i></a>
        &nbsp;<a href="https://twitter.com/drummergamesco"><i className="fa fa-lg fa-twitter-square" aria-label="Twitter logo"></i></a>
        &nbsp;<a href="https://instagram.com/drummergamesco"><i className="fa fa-lg fa-instagram" aria-label="Instagram logo"></i></a>
      </div>
      <div id="sep-tools">· · · · · · · · ·</div>
      <div className="footer-line" id="footer-tools">
        <div className="tool">
          <FormattedMessage id="menu.madeWith"/> <a href="https://reactjs.org">React</a>
        </div>
        <div className="sep">·</div>
        <div className="tool">
          <FormattedMessage id="menu.musicalNotationWith"/> <a href="https://github.com/moinejf/abc2svg">abc2svg</a>
        </div>
      </div>
    </footer>
  </div>
  
)

export default injectIntl(Menu)



// WEBPACK FOOTER //
// ./src/components/Menu.js